module.exports = __webpack_public_path__ + "img/20220219_072135.3a830f3d.jpg";